<template>
    <o-dropdown class="notification-dropdown is-pulled-right">
      <template #trigger>
        <a
            :class="{
                'navbar-item between-center': true,
                'has-notification': unreadNotifications.length,
            }"
        >
            <span class="icon is-medium" :notify-count="unreadNotificationCount"
            ><i
                class="icm-notification test"
                :class="{ 'icm-animated': unreadNotificationCount.length > 0 }"
            ></i></span
            ><span class="is-hidden-touch">Notifications</span>
        </a>
      </template>
        <o-dropdown-item
            has-link
            v-for="notification in filteredNotifications"
            :key="notification.id"
            @click="notificationAction(notification)"
        >
            <div>
                <o-icon size="is-small" pack="fa" icon="envelope"></o-icon>
                <span
                    class="link-description"
                    v-if="notification.data.message"
                    >{{ notification.data.message }}</span
                >
                <span class="datetime is-pulled-right">{{
                    $filters.datetime(notification.created_at)
                }}</span>
            </div>
        </o-dropdown-item>
        <o-dropdown-item
            has-link
            v-if="!filteredNotifications || !filteredNotifications.length"
            :custom="true"
            >Notifications not found</o-dropdown-item
        >
        <o-dropdown-item @click="viewAll()">View All</o-dropdown-item>
    </o-dropdown>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
    computed: {
        ...mapGetters(['unreadNotifications', 'unreadNotificationCount', 'notifications', 'currentUserId']),
        filteredNotifications() {
            _.forEach(this.unreadNotifications, n => n.created_at_timestamp = new Date(n.created_at).getTime())
            return _.orderBy(this.unreadNotifications, n => -n.created_at_timestamp).slice(0, 5)
        },
        UnreadNotificationsCount() {
            return this.notifications.filter(n => !n.read_at).length
        }
    },
    mounted() {
      this.fetchReminders({ user_id: this.currentUserId })

    },
    methods: {
        ...mapActions(['readNotification','fetchReminders']),
        readNotifications(isDropdownActive) {
            if (!isDropdownActive) {
                _.each(this.filteredNotifications, notification => {
                    if (!notification.read_at) {
                        notification.read_at = -1
                        this.readNotification(notification)
                    }
                })
            }
        },
        notificationAction(notification) {
            this.readNotification(notification)
            if (notification.data.action) {
                switch (notification.data.action) {
                    case 'change_order_remind_by':
                    case 'proposal_remind_by':
                        this.readNotification(notification)
                        this.navigate(notification.data.url)
                        break
                }
            } else {
                this.navigate(notification.data.url)
            }
        },
        navigate(url) {
            this.$router.push({ path: url })
        },
        viewAll() {
            this.navigate('/notifications')
        }
    }
}
</script>
<style lang="sass">
.notification-dropdown
  margin-right: 10px
  .icon
    margin-right: 10px
  .dropdown-menu
    box-shadow: #373737 1px 1px 3px
    padding-top: 0px
    background-color: white
    padding-bottom: 30px
    .dropdown-content
      width: 500px
      max-height: 227px
      overflow-y: auto
      box-shadow: none
      border-bottom: 1px solid #ececec
      a
        position: absolute
        bottom: 0px
        width: 100%
        left: 0px
        color: #019ae0
        text-align: center
      .has-link
        background: white
        &:hover
          background-color: whitesmoke
          color: #000000
        .link-description
          white-space: nowrap
          text-overflow: ellipsis
          overflow: hidden
        a,
        div
          padding: 10px 0px
          display: flex
          align-items: center
          color: #4a4a4a
          font-size: 0.875rem
          line-height: 1.5
  a,
  div
    .datetime
      padding-left: 10px
      margin-left: auto
      line-height: 1
      color: #777
      font-size: 0.8em
      width: min-content
  .dropdown-content
    padding: 5px
    cursor: pointer
    min-width: 500px
  i.icm-notification.icm-animated
    animation: ring 4s 0.7s ease-in-out infinite
@-webkit-keyframes ring
  0%
    -webkit-transform: rotateZ(0)
  1%
    -webkit-transform: rotateZ(30deg)
  3%
    -webkit-transform: rotateZ(-28deg)
  5%
    -webkit-transform: rotateZ(34deg)
  7%
    -webkit-transform: rotateZ(-32deg)
  9%
    -webkit-transform: rotateZ(30deg)
  11%
    -webkit-transform: rotateZ(-28deg)
  13%
    -webkit-transform: rotateZ(26deg)
  15%
    -webkit-transform: rotateZ(-24deg)
  17%
    -webkit-transform: rotateZ(22deg)
  19%
    -webkit-transform: rotateZ(-20deg)
  21%
    -webkit-transform: rotateZ(18deg)
  23%
    -webkit-transform: rotateZ(-16deg)
  25%
    -webkit-transform: rotateZ(14deg)
  27%
    -webkit-transform: rotateZ(-12deg)
  29%
    -webkit-transform: rotateZ(10deg)
  31%
    -webkit-transform: rotateZ(-8deg)
  33%
    -webkit-transform: rotateZ(6deg)
  35%
    -webkit-transform: rotateZ(-4deg)
  37%
    -webkit-transform: rotateZ(2deg)
  39%
    -webkit-transform: rotateZ(-1deg)
  41%
    -webkit-transform: rotateZ(1deg)
  43%
    -webkit-transform: rotateZ(0)
  100%
    -webkit-transform: rotateZ(0)
@-moz-keyframes ring
  0%
    -moz-transform: rotate(0)
  1%
    -moz-transform: rotate(30deg)
  3%
    -moz-transform: rotate(-28deg)
  5%
    -moz-transform: rotate(34deg)
  7%
    -moz-transform: rotate(-32deg)
  9%
    -moz-transform: rotate(30deg)
  11%
    -moz-transform: rotate(-28deg)
  13%
    -moz-transform: rotate(26deg)
  15%
    -moz-transform: rotate(-24deg)
  17%
    -moz-transform: rotate(22deg)
  19%
    -moz-transform: rotate(-20deg)
  21%
    -moz-transform: rotate(18deg)
  23%
    -moz-transform: rotate(-16deg)
  25%
    -moz-transform: rotate(14deg)
  27%
    -moz-transform: rotate(-12deg)
  29%
    -moz-transform: rotate(10deg)
  31%
    -moz-transform: rotate(-8deg)
  33%
    -moz-transform: rotate(6deg)
  35%
    -moz-transform: rotate(-4deg)
  37%
    -moz-transform: rotate(2deg)
  39%
    -moz-transform: rotate(-1deg)
  41%
    -moz-transform: rotate(1deg)
  43%
    -moz-transform: rotate(0)
  100%
    -moz-transform: rotate(0)
@keyframes ring
  0%
    transform: rotate(0)
  1%
    transform: rotate(30deg)
  3%
    transform: rotate(-28deg)
  5%
    transform: rotate(34deg)
  7%
    transform: rotate(-32deg)
  9%
    transform: rotate(30deg)
  11%
    transform: rotate(-28deg)
  13%
    transform: rotate(26deg)
  15%
    transform: rotate(-24deg)
  17%
    transform: rotate(22deg)
  19%
    transform: rotate(-20deg)
  21%
    transform: rotate(18deg)
  23%
    transform: rotate(-16deg)
  25%
    transform: rotate(14deg)
  27%
    transform: rotate(-12deg)
  29%
    transform: rotate(10deg)
  31%
    transform: rotate(-8deg)
  33%
    transform: rotate(6deg)
  35%
    transform: rotate(-4deg)
  37%
    transform: rotate(2deg)
  39%
    transform: rotate(-1deg)
  41%
    transform: rotate(1deg)
  43%
    transform: rotate(0)
  100%
    transform: rotate(0)
</style>